module.exports = __webpack_public_path__ + "static/media/newLogo.332661bd.png";